import {Routes} from "@angular/router";
import {Constants} from "../../constants";
import {UserRolesGuard} from "../../route-guards/user-roles.guard";
import {ShareableComponent} from "./shareable.component";
import {ShareableCartComponent} from "./shareable-cart.component";

export const SHAREABLE_ROUTES: Routes = [
    {
        path: Constants.URL_BASE_CART + '/:locale',
        canActivateChild: [UserRolesGuard],
        data: {
            restrict: [Constants.ROLES.NFR_MHP_ONLY, Constants.ROLES.EVENT]
        },
        children: [
            {
                path: Constants.SHARE_MULTIPLE_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_MULTIPLE_LINK_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_SINGLE_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_SINGLE_LINK_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_SINGLE_FB_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_SHARE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_CATEGORY_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_CATEGORY_LINK_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_CATEGORY_FB_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_TAG_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_TAG_LINK_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_TAG_FB_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_MARKETING_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_LANDING_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_URL_STATE,
                component: ShareableComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            },
            {
                path: Constants.SHARE_CART_STATE,
                component: ShareableCartComponent,
                data: {
                    roles: [Constants.ROLES.ANY],
                    group: Constants.SHAREABLE,
                    restrict: [Constants.ROLES.NFR_MHP_ONLY]
                }
            }
        ]
    }
];
